import { api } from 'shared/api'

import { DevLogsApiSchemas } from './schemas'

export const DevLogsApi = {
  fetchList: api.account.createGet({
    url: '/devLog/list',
    schemas: DevLogsApiSchemas.fetchList,
    scope: 'settings',
  }),
  fetchItem: api.account.createGet({
    url: '/devLog/get',
    schemas: DevLogsApiSchemas.fetchItem,
    scope: 'settings',
  }),
  markAsRead: api.account.createPost({
    url: '/devLog/markAsRead',
    schemas: DevLogsApiSchemas.markAsRead,
    scope: 'settings',
  }),
  fetchPolicyEnforcementLogs: api.account.createGet({
    url: '/settings/listPolicyEnforcementLogs',
    schemas: DevLogsApiSchemas.fetchPolicyEnforcementLogs,
    scope: 'settings',
  }),
}
